import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {DateTime} from 'luxon';
import { FswService } from '@services/fsw.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  public currentYear: string = DateTime.now().toFormat('y');

  public username: string = "";
  public password: string = "";
  public error: string = "";
  
  trainingRecordCount:any;
  trainingRecord:any;
  userRecord:any;
  userRecordCount:any;
  testingRecord:any;
  testingRecordCount:any;
  awpRecord:any;
  awpRecordCount:any;

  stateCode: any;

  totalVehicle:number=0;
  totalTrainings:number=0;
  totalTesting:number=0;
  totalawps:number=0;

  vehiclesData: any[] | undefined;
  trainingsData: any[] | undefined;
  testingsData: any[] | undefined;
  awpsData: any[] | undefined;

  constructor(private router: Router,private fswService: FswService) { }
  
  isLoggedIn = false;
  showloginModal = 'false';

  ngOnInit(): void {
    this.loadJsFile("assets/js/jquery.min.js"); 
    this.loadJsFile("assets/js/bootstrap.min.js"); 
    this.loadJsFile("assets/js/main.js"); 

    this.getvehicleCount();
    this.getTrainingCount();
    this.gettestingCount();
    this.getawpCount();
  }

getvehicleCount()
{
  this.totalVehicle=0;

  this.stateCode='ALL'
  this.fswService.getVehicleListCount(this.stateCode)
    .subscribe(res => {
      this.vehiclesData = res;
      this.vehiclesData.forEach(val =>{
       
        this.totalVehicle+=val.total;
         
      });
      console.log(this.totalVehicle);
    });
}
  getTrainingCount() 
  {
    this.totalTrainings=0;
    this.stateCode='ALL'
    this.fswService.getTrainingListCount(this.stateCode)
      .subscribe(res => {
        this.trainingsData = res;
        this.trainingsData.forEach(val =>{
         
          this.totalTrainings+=val.total;
           
        });
        console.log(this.totalTrainings);
      });
  }

  gettestingCount() {
 
  this.totalTesting=0;

    this.stateCode='ALL'
  
    this.fswService.getTestingListCount(this.stateCode)
      .subscribe(res => {
        this.testingsData = res;
        this.testingsData.forEach(val =>{
         
          this.totalTesting+=val.total;
           
        });
   
      });
    }
 
getawpCount() {
  
  this.totalawps=0;
  
  this.stateCode='ALL'
  
  this.fswService.getawpListCount(this.stateCode)
        .subscribe(res => {
          this.awpsData = res;
          this.awpsData.forEach(val =>{          
            this.totalawps+=val.total;             
          });
        });
  }

  

  public submit() {
  }

  logout() {

  }

  showModal(){
    this.showloginModal='true';
  }

  public loadJsFile(url:any) {  
    let node = document.createElement('script');  
    node.src = url;  
    node.type = 'text/javascript';  
    document.getElementsByTagName('head')[0].appendChild(node);  
  }  

}

